import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
//import images
import avatar1 from "assets/images/users/user-dummy-img.jpg";
import { useProfile } from "Components/Hooks/UserHooks";

const ProfileDropdown = () => {
  const { userProfile } = useProfile();

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={avatar1}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userProfile?.firstName || "User"}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                {userProfile?.role?.name || "Role"}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem className="p-0">
            <Link to="/profile" className="dropdown-item">
              <i className="ri-user-line text-muted fs-16 align-middle me-2"></i>
              <span className="align-middle">Profile</span>
            </Link>
          </DropdownItem>

          {/* <div className="dropdown-divider"></div> */}

          <DropdownItem className="p-0">
            <Link to="/logout" className="dropdown-item">
              <i className="ri-logout-box-r-line text-muted fs-16 align-middle me-2"></i>
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
